import { Button, Popover, Tooltip } from '@blueprintjs/core';
import PropTypes from 'prop-types';
import React from 'react';
import { SketchPicker } from 'react-color';
import styled from 'styled-components';
import { getColor } from 'utils/color';

export const Square = styled.div`
  display: block;
  position: absolute;
  bottom: 1px;
  left: 1px;
  right: 1px;
  height: 4px;
  margin-right: 0;
  border-radius: 2px;
  background: ${props => props.background};
`;

// TODO Button width hotfix. Why is it different? Because flexbox? But it should be disabled by absolute position.
const StyledButton = styled(Button)`
  position: relative;
  width: 30px;
`;

const ColorPickerButton = ({ icon, onChange, placement, text, value }) => {
  const square = <Square background={value} />;
  const buttonContent = (
    <>
      {square}
      {icon}
    </>
  );
  const popover = (
    <SketchPicker
      color={value}
      onChangeComplete={color => onChange(getColor(color.rgb).toRgbString())}
    />
  );
  return (
    <Popover content={popover} placement={placement}>
      <Tooltip content={text} placement={placement}>
        <StyledButton icon={buttonContent} minimal />
      </Tooltip>
    </Popover>
  );
};

ColorPickerButton.defaultProps = {
  onChange: () => {},
  placement: undefined,
  value: undefined,
};

ColorPickerButton.propTypes = {
  icon: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  placement: PropTypes.string,
  text: PropTypes.string.isRequired,
  value: PropTypes.string,
};

export default ColorPickerButton;
